var map = {
	"./AddToCart": 29,
	"./AddToCart.jsx": 29,
	"./Barcode": 74,
	"./Barcode.jsx": 74,
	"./Cart": 46,
	"./Cart.jsx": 46,
	"./Hello": 85,
	"./Hello.jsx": 85,
	"./Shop": 86,
	"./Shop.jsx": 86,
	"./useOutsideClick": 42,
	"./useOutsideClick.js": 42
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;


//////////////////
// WEBPACK FOOTER
// ./app/frontend/components ^\.\/.*$
// module id = 111
// module chunks = 0 1